import { css } from 'styled-components'
import { device } from '@styles/global/breakpoints'
import { shadowStyles } from '@styles/global/shadows'
import { colors } from '@styles/global/colors'

export default css`
	.flickity-enabled{
		outline: none;
	}
  .carousel-cell-nav{
    max-width: 187.5px;
    cursor: pointer;
    transition: .3s;
    opacity: .6;
    img{
      width: 100%;
    }
    &.v3{
      display: flex;
      background: transparent !important;
    }
    &.v4{
      display: flex;
      background: transparent !important;
      .gatsby-image-wrapper-constrained{
        display: block;
      }
    }
    &.is-selected{
      box-shadow: ${shadowStyles.shadowHover};
      opacity: 1;
    }
    
    @media ${device.laptop} {
      &:hover{
       opacity: 1;
      }
    }
    	
    
    @media ${device.laptopL} {
      box-shadow: ${shadowStyles.shadowNoHover};
      margin: 0 10px;
      max-width: 157px;
    }
    	
  }
  
  .flickity-button{
    position: absolute;
    background: hsla(0,0%,100%,0.89);
    border: none;
    color: #333;
    transition: .3s;
    display: none;

    &:disabled{
      opacity: 0.3;
      cursor: auto;
      pointer-events: none;
    }
    
    @media ${device.tablet} {
      display: flex;
    }
    	
  }
  .flickity-prev-next-button {
    top: 50%;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    &:focus{
      outline: none;
    }
    &.previous{
      left: 10px;
    }
    &.next{
      right: 10px;
    }
    svg{
      width: 100%;
    }
    path{
      fill: ${colors.primary.text};
    }
  }
`
